import { Component, Input, OnInit } from '@angular/core';
import { TransitionsActions } from '../../../application-state/store/actions';
import { filter, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Order } from '../../../orders/models';
import { PotentialAction } from '../../models';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../application-state/store';
import { FormBuilder } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { AuthService } from '../../../auth/services/auth.service';
import { BaseOnDestroyComponent } from '../../injectables/BaseOnDestroy.component';
import { ActionBoxInputTypes } from '../../models/action-box-input-types.type';

@Component({
  selector: 'app-action-box-to-analysis-in-progress',
  styleUrls: ['./action-box-to-analysis-in-progress.component.scss'],
  template: `
    <div class="action-box">
      <div class="action-required-label" *ngIf="canMakeTransition">
        Aktion erforderlich
      </div>
      <div class="action-required-label bg-green" *ngIf="!canMakeTransition">
        Warte auf Zuarbeit
      </div>
      <div class="content ">
        <div class="row" *ngIf="canMakeTransition">
          <div class=" col-auto my-2 align-items-center">
            <div class="row ">
              <div class=" col-auto header">Analyse in Bearbeitung?</div>
              <div class="sub-header col-auto">
                Ist das Speichersystem bereits zur Analyse in Bearbeitung?
              </div>
            </div>
          </div>
          <div class="actions col my-2 text-right">
            <button
              class="decision-btn me-3"
              mat-button
              color="green"
              (click)="handleMakeTransition()"
              [disabled]="!okAction || !canMakeTransition"
            >
              <mat-icon class="me-2">done</mat-icon>
              <span>Ja</span>
            </button>
          </div>
        </div>
        <div class="row " *ngIf="!canMakeTransition">
          <div class=" col-auto header">Warte auf Beginn der Analyse</div>
          <div class="sub-header col-auto" *ngIf="isInternal">
            Die Technik muss bestätigen, dass mit der Analyse begonnen wurde.
          </div>
          <div class="sub-header col-auto" *ngIf="!isInternal">
            Das <strong>Externe Labor</strong> muss bestätigen, dass mit der
            Analyse begonnen wurde.
          </div>
        </div>
      </div>
    </div>
  `
})
export class ActionBoxToAnalysisInProgressComponent
  extends BaseOnDestroyComponent
  implements OnInit {
  @Input() order$: Observable<Order>;
  @Input() inputType: ActionBoxInputTypes;

  order: Order;
  okAction: PotentialAction = null;

  constructor(
    private store$: Store<ApplicationState>,
    private fb: FormBuilder,
    private actions$: Actions,
    private authService: AuthService
  ) {
    super();
  }

  get canMakeTransition(): boolean {
    return (
      (this.inputType === 'ticket' &&
        ((this.okAction?.transition?.indexOf('_dr_ext') > -1 &&
          this.authService.isTechnicianExternal()) ||
          (this.okAction?.transition?.indexOf('_dr_de') > -1 &&
            this.authService.isTechnician()) ||
          this.authService.isAdmin() ||
          this.authService.isSupervisor())) ||
      false
    );
  }

  get isInternal(): boolean {
    return this.okAction?.transition?.indexOf('_dr_de') > -1;
  }

  ngOnInit(): void {
    this.order$
      .pipe(
        takeUntil(this.onDestroy$),
        filter(order => !!order)
      )
      .subscribe(order => {
        this.order = order;
        this.okAction = order.potentialActions?.find(
          e => e.transition.indexOf('to_analysis_in_progress') > -1 && !e.error
        );
      });
  }

  handleMakeTransition(): void {
    const action = this.okAction;
    if (!action) {
      return;
    }
    const uri = `${this.order['@id']}/transitions?workflow=${action.workflow}&transition=${action.transition}`;
    const payload = {
      workflow: action.workflow,
      transition: action.transition
    };
    this.store$.dispatch(TransitionsActions.MakeTransition({ uri, payload }));
  }
}
